<template>
  <span id="top">
    <div class="banner p1-3 mt-3">CONTACT US</div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">
          <ul>
            <li>
              If you have any questions, inquires or issues for PGP Title please
              email them to:
              <a href="mailto:info@pulte.com" target="_top">info@pulte.com</a>
            </li>
            <li>
              Otherwise, if you have questions related to your closing you can
              call or email your local branch with the information located
              below:
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-8 offset-md-2 text-center">
          <LocationItem :office="getHomeOffice()" />
        </div>
        <div class="col-12 col-lg-10 offset-lg-1">
          <h2 id="mortgage_brance_offices_header">PGP Title Locations:</h2>
          <Map @stateSelected="StateSelected" />
          <div
            v-for="state of sortedStates()"
            v-bind:key="state.state"
            :id="strippedState(state.state)"
          >
            <h3 class="StateName">
              {{ state.state }}
              <small
                ><button class="top-button" v-on:click="goHome()">
                  (top)
                </button></small
              >
            </h3>
            <div class="container-fluid text-md-center" id="footerlinks">
              <div class="row">
                <div
                  class="col-12 col-md-6 office-col"
                  v-for="office of state.offices"
                  v-bind:key="office.name"
                >
                  <LocationItem :office="office" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<style scoped>
div {
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
}

h2 {
  font-size: 30px;
  text-align: left;
  margin: 0 0 8px;
  font-weight: bold;
}

h3 {
  font-size: 20px;
}

li {
  text-align: left;
  font-size: 16px;
  color: #202a2f;
  margin: 0 0 12px;
  list-style-image: url("data:image/gif;base64,R0lGODlhAwAFAKIEAMWjWsSiWsWjW8WiWv///wAAAAAAAAAAACH5BAEAAAQALAAAAAADAAUAQAMJGESwEgEMJkgCADs=");
}

.office-col {
  display: flex;
  margin-bottom: 1rem;
}

.StateName {
  font-weight: bold;
}

.top-button {
  font-weight: bold;
  background-color: transparent;
  border-style: none;
  color: inherit;
}
</style>

<script setup>
import { onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import homeoffice from "../../data/homeoffice.json";
import locations from "../../data/contacts.json";
import LocationItem from "../LocationItem";
import Map from "../Map";

const route = useRoute();
const router = useRouter();
const STATE_SCROLL_OFFSET = 100;

const goHome = () => {
  const top = document.querySelector("#top");
  if (top) {
    top.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

const strippedState = (arg) => arg.replace(/\s+/g, "");

const sortedStates = () => {
  return locations.slice().sort((a, b) => (a.state > b.state ? 1 : -1));
};

const getHomeOffice = () => homeoffice;

const StateSelected = (value) => {
  router.push({ path: "/ContactUs/" + value });
  const id = strippedState(value);
  const target = document.querySelector("#" + id);
  if (target) {
    window.scrollTo({
      top:
        window.scrollY +
        target.getBoundingClientRect().top -
        STATE_SCROLL_OFFSET,
      behavior: "smooth",
    });
  }
};

const scrollToStateFromRoute = (stateParam) => {
  if (!stateParam) {
    return;
  }
  const dest = strippedState(String(stateParam));
  setTimeout(() => {
    const target = document.querySelector("#" + dest);
    if (target) {
      window.scrollTo({
        top:
          window.scrollY +
          target.getBoundingClientRect().top -
          STATE_SCROLL_OFFSET,
        behavior: "smooth",
      });
    }
  }, 250);
};

onMounted(() => {
  if (route.params.state) {
    scrollToStateFromRoute(route.params.state);
  }
});

watch(
  () => route.params.state,
  (nextState) => {
    if (nextState) {
      scrollToStateFromRoute(nextState);
    }
  },
);
</script>
